import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type HowItWorksPhoneProps = {
  children: ReactNode;
  className?: string;
};

export function HowItWorksPhone({ children, className }: HowItWorksPhoneProps) {
  return (
    <div
      className={cn(
        "relative mx-auto w-[220px] shrink-0 sm:w-[260px]",
        "aspect-[9/19.5] rounded-[2.25rem] bg-gradient-to-b from-[#3a3a3c] via-[#1c1c1e] to-black p-[3px]",
        "shadow-[0_24px_48px_-12px_rgba(0,0,0,0.45)]",
        className,
      )}
    >
      <div className="relative h-full w-full overflow-hidden rounded-[2rem] bg-black">
        <div
          className="pointer-events-none absolute left-1/2 top-[8px] z-20 h-[22px] w-[72px] -translate-x-1/2 rounded-full bg-black"
          aria-hidden
        />
        <div className="absolute inset-[2px] overflow-hidden rounded-[1.85rem] bg-white">
          {children}
        </div>
      </div>
    </div>
  );
}
